// Shared LVGL default colors for LVGL-only layers.
export const LVGL_DEFAULT_COLOR_ACCENT = '#2196f3';
export const LVGL_DEFAULT_COLOR_SECONDARY = '#CCCCCC';
export const LVGL_DEFAULT_COLOR_BLANK = '#FFFFFF';
export const LVGL_DEFAULT_COLOR_TEXT = '#000000';

// Checkbox constants
export const LVGL_CHECKBOX_TEXT_SCALE = 14;
export const LVGL_CHECKBOX_TEXT_GAP = 8;
export const LVGL_CHECKBOX_BOX_SIZE = 19;
export const LVGL_CHECKBOX_RADIUS = 2;

// Panel defaults
export const LVGL_PANEL_DEFAULT_BG_COLOR = LVGL_DEFAULT_COLOR_BLANK;
export const LVGL_PANEL_DEFAULT_BORDER_COLOR = LVGL_DEFAULT_COLOR_SECONDARY;
export const LVGL_PANEL_DEFAULT_BORDER_WIDTH = 2;
export const LVGL_PANEL_DEFAULT_RADIUS = 6;

// Button defaults
export const LVGL_BUTTON_DEFAULT_BG_COLOR = LVGL_DEFAULT_COLOR_ACCENT;
export const LVGL_BUTTON_DEFAULT_TEXT_COLOR = LVGL_DEFAULT_COLOR_BLANK;
export const LVGL_BUTTON_DEFAULT_RADIUS = 13;

// Switch defaults
export const LVGL_SWITCH_DEFAULT_COLOR = LVGL_DEFAULT_COLOR_ACCENT;
export const LVGL_SWITCH_DEFAULT_BG_COLOR = LVGL_DEFAULT_COLOR_SECONDARY;

// Slider defaults
export const LVGL_SLIDER_DEFAULT_COLOR = LVGL_DEFAULT_COLOR_ACCENT;

// Checkbox color defaults
export const LVGL_CHECKBOX_DEFAULT_TEXT_COLOR = LVGL_DEFAULT_COLOR_TEXT;
export const LVGL_CHECKBOX_DEFAULT_BG_COLOR = LVGL_DEFAULT_COLOR_BLANK;
export const LVGL_CHECKBOX_DEFAULT_BORDER_COLOR = LVGL_DEFAULT_COLOR_ACCENT;

// Default TTF font size (Montserrat). Used to reverse the text Y offset on import.
export const LVGL_DEFAULT_TTF_FONT_SIZE = 14;

// TextArea defaults (inherits from Panel)
export const LVGL_TEXTAREA_DEFAULT_BG_COLOR = LVGL_DEFAULT_COLOR_BLANK;
export const LVGL_TEXTAREA_DEFAULT_BORDER_COLOR = LVGL_DEFAULT_COLOR_SECONDARY;
export const LVGL_TEXTAREA_DEFAULT_BORDER_WIDTH = 2;
export const LVGL_TEXTAREA_DEFAULT_RADIUS = 6;
export const LVGL_TEXTAREA_DEFAULT_TEXT_COLOR = LVGL_DEFAULT_COLOR_TEXT;
